import { useMemo } from 'react';

import { useNavigate, useLocation } from 'react-router';
import { Button, Container, Stack } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBuoyMooring } from '@fortawesome/pro-duotone-svg-icons';

import Header from '@components/Header/HeaderNav';
import Footer from '@components/Footer/Footer';
import { BRAND_PRE } from '@constants/constants';
import useAuth from '@hooks/useAuth';
import { ROUTE_PATHS } from '@router/paths';

import { ErrorMessageByCode, ERROR_MESSAGES_BY_CODE, DEFAULT_ERROR_MESSAGE } from './constants';
import './errorPage.scss';

export default function ErrorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, onLogout } = useAuth();
  const errorCode = useMemo(() => location.state?.errorCode, [location.state?.errorCode]);

  const { title, subtitle, code, errorString }: ErrorMessageByCode = useMemo(() => {
    const data = ERROR_MESSAGES_BY_CODE.find(item => item.code === errorCode);

    return data ?? DEFAULT_ERROR_MESSAGE;
  }, [errorCode]);

  const onBtnClick = () => {
    if (errorCode === 401) {
      onLogout();
    } else {
      navigate(isLoggedIn ? ROUTE_PATHS.REQUISITION_LIST : ROUTE_PATHS.ROOT);
    }
  };

  return (
    <Stack>
      <Header />
      <div className={`d-flex flex-grow-1 position-relative ${BRAND_PRE}error-container`}>
        <Container fluid='xxl' className='d-flex flex-column py-4 error-content'>
          <div className='error-content-inner text-center d-flex flex-column flex-grow-1 py-5 rounded-2'>
            <Stack gap={4} className='justify-content-center p-3 h-100'>
              <FontAwesomeIcon icon={faBuoyMooring as IconDefinition} fontSize={64} className='text-primary' />
              <h1 className='mb-0 fs-3 lh-xs'>{title}</h1>
              <div className='fs-6'>
                {subtitle}
                <span className='d-block mt-2 fs-xs fw-bold'>{`${code}: ${errorString}`}</span>
              </div>
              <Button onClick={onBtnClick} className='align-self-center'>
                {errorCode === 401 ? 'Logout' : 'Back to home'}
              </Button>
            </Stack>
          </div>
        </Container>
      </div>

      <Footer />
    </Stack>
  );
}
